import React, { useState } from 'react';
import adminAuthService from '../services/authService';
import './ChangePasswordModal.css';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPasswords, setShowPasswords] = useState({
    current: false, new: false, confirm: false,
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError(''); setSuccess('');
  };

  const toggleShow = (field) => {
    setShowPasswords(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = formData;
    if (!currentPassword || !newPassword || !confirmPassword) { setError('All fields are required'); return; }
    if (newPassword.length < 8) { setError('New password must be at least 8 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    if (currentPassword === newPassword) { setError('New password must differ from current'); return; }

    setLoading(true); setError('');
    try {
      await adminAuthService.changePassword(currentPassword, newPassword, confirmPassword);
      setSuccess('Password changed successfully!');
      setTimeout(() => handleClose(), 1500);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to change password');
    } finally { setLoading(false); }
  };

  const handleClose = () => {
    setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setError(''); setSuccess('');
    setShowPasswords({ current: false, new: false, confirm: false });
    onClose();
  };

  const fields = [
    { key: 'current', name: 'currentPassword', label: 'Current Password' },
    { key: 'new', name: 'newPassword', label: 'New Password' },
    { key: 'confirm', name: 'confirmPassword', label: 'Confirm New Password' },
  ];

  return (
    <div className="cpw-overlay" onClick={handleClose}>
      <div className="cpw-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cpw-header">
          <div>
            <h3 className="cpw-title">Change Password</h3>
            <p className="cpw-desc">Update your admin account password</p>
          </div>
          <button className="cpw-close" onClick={handleClose} type="button">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {error && <div className="cpw-alert cpw-alert--error">{error}</div>}
        {success && <div className="cpw-alert cpw-alert--success">{success}</div>}

        <form onSubmit={handleSubmit} className="cpw-form">
          {fields.map(({ key, name, label }) => (
            <div className="cpw-field" key={key}>
              <label className="cpw-label">{label}</label>
              <div className="cpw-input-wrap">
                <input
                  type={showPasswords[key] ? 'text' : 'password'}
                  name={name} value={formData[name]}
                  onChange={handleChange}
                  placeholder={`Enter ${label.toLowerCase()}`}
                  className="cpw-input"
                  disabled={loading || !!success}
                />
                <button type="button" className="cpw-toggle" onClick={() => toggleShow(key)} tabIndex={-1}>
                  {showPasswords[key] ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
          ))}

          <div className="cpw-actions">
            <button type="button" className="cpw-btn cpw-btn--secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="cpw-btn cpw-btn--primary" disabled={loading || !!success}>
              {loading ? <><span className="cpw-spinner" /> Changing...</> : success ? '✓ Changed!' : 'Change Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;